$(() => {
    let otpInterval = null;
    window.showAlert = function (messageType, message) {
        if (messageType && message !== "") {
            var alertId = Math.floor(Math.random() * 1000);
            var html =
                '<div class="alert '
                    .concat(messageType, ' alert-dismissible" id="')
                    .concat(
                        alertId,
                        '">\n                <span class="btn-close" data-bs-dismiss="alert" aria-label="close"></span>\n                <i class="fas fa-',
                    ) +
                (messageType === "alert-success"
                    ? "check-circle"
                    : "exclamation-circle") +
                ' message-icon"></i>\n                '.concat(
                    message,
                    "\n            </div>",
                );
            $("#alert-container")
                .append(html)
                .ready(function () {
                    window.setTimeout(function () {
                        $("#alert-container #".concat(alertId)).remove();
                    }, 6000);
                });
        }
    };
    const showError = (message) => {
        window.showAlert("alert-danger", message);
    };

    const showSuccess = (message) => {
        window.showAlert("alert-success", message);
    };
    function loadProvinces() {
        $.get("/local/province", function (res) {
            let html = '<option value="">Chọn tỉnh / thành phố</option>';

            res.provinces.forEach(function (item) {
                html += `<option value="${item.id}">${item.name.trim()}</option>`;
            });

            let $select = $("#provinceSelect");

            $select.html(html);

            // refresh nice-select
            $select.niceSelect("update");
        });
    }
    function countDownOTP() {
        if (otpInterval) clearInterval(otpInterval);

        let count = 180;

        $(".btn_resend_sdt_otp, .btn_resend_email_otp").prop("disabled", true);
        $(".otp_count_down").text(count);

        otpInterval = setInterval(() => {
            count--;
            $(".otp_count_down").text(count);

            if (count <= 0) {
                clearInterval(otpInterval);

                $(".btn_resend_sdt_otp, .btn_resend_email_otp").prop(
                    "disabled",
                    false,
                );
            }
        }, 1000);
    }

    function handleOTP(phone, email) {
        if (phone) {
            $("#phone_request_otp").val(phone);

            $("#verifySDTOTPModal").modal("show");
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open");

            $.get("/verify-sdt-otp", { phone }, function (res) {
                if (res.error == true) showError(res.message);
                else showSuccess(res.message);
            });
        } else if (email) {
            $("#email_request_otp").val(email);

            $("#verifyEmailOTPModal").modal("show");
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open");

            $.get("/verify-email-otp", { email }, function (res) {
                if (res.error == true) showError(res.message);
                else showSuccess(res.message);
            });
        }

        countDownOTP();
    }

    function submitAuthForm($form, $btn) {
        $.ajax({
            url: $form.attr("action"),
            method: "POST",
            dataType: "json",
            data: $form.serialize(),

            success: function (res) {
                const verify = res?.data?.verify_otp;
                const phone = res?.data?.phone;
                const email = res?.data?.email;
                const bosung = res?.data?.bosung;

                if (verify === 0) {
                    handleOTP(phone, email);
                } else if (bosung === 1) {
                    $("#emailBoSungThongTin").val(
                        $form.find('[name="email"]').val(),
                    );

                    $("#passwordBoSungThongTin").val(
                        $form.find('[name="password"]').val(),
                    );

                    $("#modalBoSungThongTin").modal("show");
                    $(".modal-backdrop").remove();
                    $("body").removeClass("modal-open");
                    loadProvinces();
                } else {
                    window.location.href = "/";
                }
            },

            error: function (err) {
                if (err.status === 422) {
                    let errors = err.responseJSON.errors;

                    let message = Object.values(errors).flat().join("<br>");

                    showError(message);

                    return;
                }
            },

            complete: function () {
                $btn.prop("disabled", false).removeClass("button-loading");
            },
        });
    }

    function resendOTP(url, data, btn) {
        btn.prop("disabled", true).addClass("button-loading");

        $.ajax({
            url: url,
            method: "GET",
            data: data,

            success: (res) => {
                btn.prop("disabled", false).removeClass("button-loading");

                if (res.error == true) {
                    showError(res.message);
                    return;
                }

                showSuccess(res.message);

                countDownOTP();
            },

            error: () => {
                btn.prop("disabled", false).removeClass("button-loading");
            },
        });
    }

    function validateLoginForm(form) {
        let email = form.find('[name="email"]').val().trim();
        let password = form.find('[name="password"]').val();

        let errors = [];

        // email hoặc phone bắt buộc
        if (!email) {
            errors.push("Vui lòng nhập Email hoặc Số điện thoại");
        }

        // password bắt buộc
        if (!password) {
            errors.push("Vui lòng nhập Mật khẩu");
        }

        if (errors.length > 0) {
            showError(errors.join("<br>"));
            return false;
        }

        return true;
    }

    function validateRegisterForm(form) {
        let email = form.find('[name="email"]').val().trim();
        let phone = form.find('[name="phone"]').val().trim();
        let password = form.find('[name="password"]').val();
        let password_confirmation = form
            .find('[name="password_confirmation"]')
            .val();
        let full_name = form.find('[name="full_name"]').val().trim();

        let agree_terms = form
            .find('[name="agree_terms_and_policy"]')
            .is(":checked");
        let agree_limit = form
            .find('[name="agree_account_limit"]')
            .is(":checked");
        let agree_info = form
            .find('[name="agree_information_accuracy"]')
            .is(":checked");

        let errors = [];

        // email hoặc phone bắt buộc
        if (!email && !phone) {
            errors.push("Vui lòng nhập Email hoặc Số điện thoại");
        }

        // email format
        if (email) {
            let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                errors.push("Email không hợp lệ");
            }
        }

        // password
        if (!password) {
            errors.push("Mật khẩu không được bỏ trống");
        } else {
            if (password.length < 8) {
                errors.push("Mật khẩu phải tối thiểu 8 ký tự");
            }

            let passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;

            if (!passwordRegex.test(password)) {
                errors.push("Mật khẩu phải có chữ hoa, số và ký tự đặc biệt");
            }
        }

        // confirm password
        if (password !== password_confirmation) {
            errors.push("Mật khẩu xác nhận không khớp");
        }

        // full name
        if (!full_name) {
            errors.push("Họ và tên không được bỏ trống");
        }

        // checkbox
        if (!agree_terms) {
            errors.push("Bạn phải đồng ý điều khoản sử dụng");
        }

        if (!agree_limit) {
            errors.push("Bạn phải đồng ý giới hạn tài khoản");
        }

        if (!agree_info) {
            errors.push("Bạn phải xác nhận thông tin chính xác");
        }

        if (errors.length > 0) {
            showError(errors.join("<br>"));
            return false;
        }

        return true;
    }

    function validateAdditionalInfoForm(form) {
        let email = $(form).find('[name="emailThongtin"]').val().trim();
        let password = $(form).find('[name="passwordThongtin"]').val();
        let name = $(form).find('[name="name"]').val().trim();
        let phone = $(form).find('[name="phone"]').val().trim();
        let avatarInput = $(form).find('[name="avatar"]')[0];

        let errors = [];

        // name
        if (!name) {
            errors.push("Họ và tên không được bỏ trống");
        }

        // phone
        if (!phone) {
            errors.push("Số điện thoại không được bỏ trống");
        }

        // kiểm tra định dạng phone
        let phoneRegex = /^[0-9]{9,11}$/;
        if (phone && !phoneRegex.test(phone)) {
            errors.push("Số điện thoại không hợp lệ");
        }

        // avatar
        if (avatarInput && avatarInput.files.length > 0) {
            let avatar = avatarInput.files[0];

            if (avatar.size > 2 * 1024 * 1024) {
                errors.push("Ảnh đại diện tối đa 2MB");
            }
        }

        if (errors.length > 0) {
            console.log(errors.join("<br>"));

            showError(errors.join("<br>"));
            return false;
        }

        return true;
    }

    $(document).on("click", ".btn_ajax_register", function (event) {
        event.preventDefault();

        const $btn = $(this);
        const $form = $btn.closest("form");
        const isValid = validateRegisterForm($form);

        if (!isValid) return;

        $btn.prop("disabled", true).addClass("button-loading");

        submitAuthForm($form, $btn);
    });

    $(document).on("click", ".btn_ajax_login", function (event) {
        event.preventDefault();

        const $btn = $(this);
        const $form = $btn.closest("form");
        const isValid = validateLoginForm($form);

        if (!isValid) return;

        $btn.prop("disabled", true).addClass("button-loading");

        submitAuthForm($form, $btn);
    });

    $(document).on("click", ".btn_resend_sdt_otp", function (event) {
        event.preventDefault();

        const btn = $(this);
        const phone = $("#phone_request_otp").val();

        resendOTP(btn.data("url"), { phone }, btn);
    });

    $(document).on("click", ".btn_resend_email_otp", function (event) {
        event.preventDefault();

        const btn = $(this);
        const email = $("#email_request_otp").val();

        resendOTP(btn.data("url"), { email }, btn);
    });

    $(document).on("click", ".btn_ajax_verify_sdt_otp", function (event) {
        event.preventDefault();

        const btn = $(this);

        const token = $('meta[name="csrf-token"]').attr("content");

        const phone = $("#phone_request_otp").val();

        const otp = $("#otpPhoneRegister").val();

        if (!otp) {
            showError("Vui lòng nhập mã OTP");
            return;
        }

        btn.prop("disabled", true).addClass("button-loading");

        $.ajax({
            url: btn.data("url"),
            method: "POST",
            dataType: "json",

            data: {
                _token: token,
                phone: phone,
                otp: otp,
            },

            success: (res) => {
                btn.prop("disabled", false).removeClass("button-loading");

                if (res.error == true) {
                    showError(res.message);
                    return;
                }

                showSuccess(res.message);

                $("#otpPhoneRegister").val("");

                $("#verifySDTOTPModal").modal("hide");

                window.location.href = "/login";
            },

            error: () => {
                btn.prop("disabled", false).removeClass("button-loading");
            },
        });
    });

    $(document).on("click", ".btn_ajax_verify_email_otp", function (event) {
        event.preventDefault();

        const btn = $(this);

        const token = $('meta[name="csrf-token"]').attr("content");

        const email = $("#email_request_otp").val();

        const otp = $("#otpEmailRegister").val();

        if (!otp) {
            showError("Vui lòng nhập mã OTP");
            return;
        }

        btn.prop("disabled", true).addClass("button-loading");

        $.ajax({
            url: btn.data("url"),
            method: "POST",
            dataType: "json",

            data: {
                _token: token,
                email: email,
                otp: otp,
            },

            success: (res) => {
                btn.prop("disabled", false).removeClass("button-loading");

                if (res.error == true) {
                    showError(res.message);
                    return;
                }

                showSuccess(res.message);

                $("#otpEmailRegister").val("");

                $("#verifyEmailOTPModal").modal("hide");

                window.location.href = "/login";
            },

            error: () => {
                btn.prop("disabled", false).removeClass("button-loading");
            },
        });
    });

    $(document).on("click", ".btn_save_profile", function () {
        let url = $(this).data("url");
        let form = $(this).closest("form");
        let isValid = validateAdditionalInfoForm(form);
        console.log(!isValid);

        if (!isValid) return;

        let formData = new FormData();

        formData.append("email", $(form).find('[name="emailThongtin"]').val());
        formData.append(
            "password",
            $(form).find('[name="passwordThongtin"]').val(),
        );
        formData.append("name", $(form).find('[name="name"]').val());
        formData.append("province", $(form).find('[name="province"]').val());
        formData.append("bio", $(form).find('[name="bio"]').val());
        formData.append("phone", $(form).find('[name="phone"]').val());

        let avatar = $(form).find('[name="avatar"]')[0].files[0];
        if (avatar) formData.append("avatar", avatar);

        $.ajax({
            url: url,
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },

            success: function (res) {
                console.log(res);
                if (res.error == true) {
                    showError(res.message);
                    return;
                }

                showSuccess(res.message);
                window.location.href = "/";
            },

            error: function (err) {
                console.log(err);
                if (err.status === 422) {
                    let errors = err.responseJSON.errors;

                    let message = Object.values(errors).flat().join("<br>");

                    showError(message);

                    return;
                }
            },
        });
    });

    const radios = document.querySelectorAll(
        'input[name=\"participation_type\"]',
    );
    const sellerDiv = document.getElementById("seller_type_div");

    radios.forEach((radio) => {
        radio.addEventListener("change", function () {
            if (this.value === "seller") {
                sellerDiv.style.display = "block";
            } else {
                sellerDiv.style.display = "none";
            }
        });
    });
});
